import messages from './tag-messages.js';
export default [
    {tag: 'animals', intlLabel: messages.animals},
    {tag: 'nature', intlLabel: messages.nature},
    {tag: 'fighting', intlLabel: messages.fighting},
    {tag: 'weapons', intlLabel: messages.weapons},
    {tag: 'magic', intlLabel: messages.magic},
    {tag: 'monsters', intlLabel: messages.monsters},
    {tag: 'effects', intlLabel: messages.effects}
];
